(function() {
    'use strict';

    angular
        .module('gwApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider','$rootScopeProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('invoice', {
                parent: 'module',
                url: '/invoice',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/invoice/invoice.html',
                        controller: 'InvoiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('invoiceDetail', {
                parent: 'module',
                url: '/invoiceDetail/{id}',
                params:{page: null},
                data: {
                    authorities: ['ROLE_DELIVER']
                },
                views: {
                    'content': {
                        templateUrl: 'app/invoice/invoice-detail.html',
                        controller: 'InvoiceDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'DeliveryRequest', function($stateParams, DeliveryRequest) {
                        return DeliveryRequest.get({id : $stateParams.id});
                    }]
                }
            });
    }
})();
